import { Brand, IAccount, IAccountProject, NavigationTabType } from '@models';
import _ from 'lodash';
import { app as routes } from '@configs/routes.json';
import { RequestStatus } from '@store/types/request';

export type BrandConfig = {
  name: Brand;
  experimentFormat: 'csv' | 'tsv';
  experimentFilename: string;
  defaultTabs: NavigationTabType[];
};

export interface IProjectPicker {
  activeAccountId: string | null;
  activeProjectId: string | null;
  accountsList: IAccount[] | null;
  projectsList: IAccountProject[] | null;
  getProjectsStatus: RequestStatus;
  history: IAccountProject[];
  hasSampleLevelDocuments: boolean;
  reportNumberPrefix: string;
  timeZone: string;
  config?: BrandConfig;
}

export enum ProjectPickerActionTypes {
  UPDATE_ACCOUNT_ID = 'projectPicker/updateAccountId',
  UPDATE_PICKER = 'projectPicker/updatePicker',
  UPDATE_ACCOUNTS_LIST = 'projectPicker/updateAccountsList',
  UPDATE_PROJECTS_LIST = 'projectPicker/updateProjectsList',
  REQUEST_PROJECTS_LIST = 'projectPicker/requestProjectsList',
}

export const getActiveProject = (
  projectPicker: IProjectPicker
): IAccountProject | undefined => {
  return _.find(
    projectPicker.projectsList,
    (project: IAccountProject) =>
      project.projectId === projectPicker.activeProjectId
  );
};
//TODO Sharmin: Refactor how Routes work so that default route includes almost there & TOS
export const getProjectDepDefaultAuthRoute = (
  projectPicker?: IProjectPicker
) => {
  const defaultRoute = routes.orders;
  if (projectPicker && projectPicker.projectsList) {
    let activeProject = getActiveProject(projectPicker);
    if (
      activeProject &&
      activeProject.customProperties &&
      activeProject.customProperties.tabs
    ) {
      switch (activeProject.customProperties.tabs[0]) {
        case NavigationTabType.ORDERS:
          return routes.orders;
        case NavigationTabType.RESULTS:
          return routes.results;
        case NavigationTabType.UPLOAD:
          return routes.uploads;
        case NavigationTabType.HELP:
          return routes.help;
        case NavigationTabType.FILES:
          return routes.files;
        default:
          return defaultRoute;
      }
    } else {
      return defaultRoute;
    }
  } else {
    return defaultRoute;
  }
};
